<template>
  <el-dialog
    :title="$t('editPrivilegeGroup.editRole')"
    :visible.sync="dialogVisible"
    width="50%"
  >
    <el-form :model="editPrivilegeGroupInfo" :rules="rules" ref="form">
      <p v-if="editPrivilegeGroupInfo.errorInfo" style="color:red;">
        {{ editPrivilegeGroupInfo.errorInfo }}
      </p>
      <el-form-item 
        :label="$t('editPrivilegeGroup.roleName')" 
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="editPrivilegeGroupInfo.name"
          :placeholder="$t('editPrivilegeGroup.roleNamePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('editPrivilegeGroup.roleDesc')"
        prop="description"
        :label-width="formLabelWidth"
      >
        <el-input
          type="textarea"
          v-model="editPrivilegeGroupInfo.description"
          :placeholder="$t('editPrivilegeGroup.roleDescPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveEditPrivilegeGroup">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updatePrivilegeGroup } from '@/api/frame/privilegeGroupApi'

export default {
  name: 'EditPrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      editPrivilegeGroupInfo: {
        pgId: '',
        name: '',
        description: '',
        errorInfo: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('editPrivilegeGroup.roleNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('editPrivilegeGroup.roleNameLength'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('editPrivilegeGroup.roleDescLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editPrivilegeGroupInfo = {
        pgId: row.pgId,
        name: row.name,
        description: row.description,
        errorInfo: ''
      }
    },
    async saveEditPrivilegeGroup() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.editPrivilegeGroupInfo.errorInfo = ""
        const res = await updatePrivilegeGroup(this.editPrivilegeGroupInfo)
        
        if (res.code === 0) {
          this.$message.success(this.$t('editPrivilegeGroup.editSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('修改权限组失败:', error)
        this.editPrivilegeGroupInfo.errorInfo = error.message
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>